import { Button } from "./StyledComponents";


export function SideNav() {

  function onClose() {
    document.getElementById("mySidenav").style.width = "0";
    document.getElementById("main").style.marginLeft= "0";
  };

  return (
    <div id="mySidenav" class="sidenav">
      <Button className="closebtn" onClick={onClose}>&times;</Button>
      <a href="/language">Language - Javascript</a>
      <a href="/framework">Framework - React JS Web</a>
      <a href="/libraries">Libraries - React JS Web</a>
      <a href="/markup-styling">Markup and Styling</a>
      <a href="/testing">Code-Based Testing – React JS Web</a>
      <a href="/design">Design</a>
      <a href="/dev-env">Development Environments – React JS Web</a>
      <a href="/cloud-env">Cloud Environments</a>
      <a href="/project-process">Project Process</a>
      <a href="/tech-process">Technical Process</a>
      <a href="/contribution">Expertise Contribution</a>
      <a href="/gen-ai">Generative AI</a>
    </div>
  );
}